import { useEffect } from "react";

const DEFAULT_DESC =
  "Neurobolt.AI — a research-stage platform for AI-powered neuroplasticity through biocompatible brain-interface technology. Rewire, Refine, Redefine.";

/**
 * Sets document.title and updates meta description + og tags on mount.
 * Lightweight replacement for react-helmet (zero deps).
 */
export function useDocumentMeta({ title, description, path } = {}) {
  useEffect(() => {
    const fullTitle = title
      ? `${title} — Neurobolt.AI`
      : "Neurobolt.AI — Rewire, Refine, Redefine";
    document.title = fullTitle;

    const desc = description || DEFAULT_DESC;
    setMeta("name", "description", desc);
    setMeta("property", "og:title", fullTitle);
    setMeta("property", "og:description", desc);
    if (path) {
      setMeta("property", "og:url", `https://neurobolt.ai${path}`);
      setMeta("rel", "canonical", `https://neurobolt.ai${path}`, "href");
    }
  }, [title, description, path]);
}

function setMeta(attr, name, value, valueAttr = "content") {
  const sel =
    attr === "rel"
      ? `link[rel="${name}"]`
      : `meta[${attr}="${name}"]`;
  let el = document.head.querySelector(sel);
  if (!el) {
    el = document.createElement(attr === "rel" ? "link" : "meta");
    if (attr === "rel") el.setAttribute("rel", name);
    else el.setAttribute(attr, name);
    document.head.appendChild(el);
  }
  el.setAttribute(valueAttr, value);
}
